module.exports = __webpack_public_path__ + "static/intro-to-coding-c927df88b95b60ade04c7f1d541fddbe.png";